import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

type TMifosProductQuery = {
  productType: number;
  tenantId?: string;
};

const getMifosProduct = async ({
  productType,
  tenantId,
}: TMifosProductQuery) => {
  let query = `?producttype=${productType}`;

  if (tenantId) {
    query = `${query}&TenantId=${tenantId}`;
  }

  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_MIFOS_PRODUCTS_DETAILS}${query}`
  );
  return data;
};

export default function useMifosProduct({
  productType,
  tenantId,
}: TMifosProductQuery) {
  return useQuery(
    [{ productType, tenantId }, "getMifosProduct"],
    getMifosProduct,
    {
      refetchOnWindowFocus: false,
      enabled: tenantId ? true : false,
    }
  );
}
